import { render, staticRenderFns } from "./couponGiveProvide.vue?vue&type=template&id=7959ad98&"
import script from "./couponGiveProvide.vue?vue&type=script&lang=js&"
export * from "./couponGiveProvide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports